import SportSelection from './SportSelection';
import SpecialOdd from '../specials/SpecialOdd';
import Rule from '../shared/betSlip/Rule';
import { SelectionType } from '../shared/betSlip/betSlipEnums';
import SpecialEvent from '../specials/SpecialEvent';

export default class SpecialSelection extends SportSelection {
    type = SelectionType.special;
    odd: SpecialOdd;
    event: SpecialEvent;

    public getOdd() {
        return this.odd;
    }

    get name() {
        return this.odd.description;
    }

    get displayName() {
        const secondaryName = this.event.masterName
            ? `${this.event.masterName} - ${this.event.fullName}`
            : this.event.fullName;
        return `${this.odd.marketName} (${secondaryName})`;
    }

    get negotiationName() {
        const specialName = this.event.fullName;
        const specialMarketEventName = this.odd.marketName;
        return `${specialMarketEventName} (${specialName})`;
    }

    get eventId() {
        return this.odd.eventId;
    }

    getEventId() {
        return this.odd.eventId;
    }

    getSpecialOfferId(): number | undefined {
        return this.event.id;
    }

    isAvailableForBetting() {
        return this.event.isAvailableForBetting();
    }

    getBettingPeriod() {
        return {
            betStart: this.odd.betStart,
            betEnd: this.odd.betEnd,
        };
    }

    public getRules(): Rule[] {
        return this.odd ? this.odd.rules : [];
    }

    existsFor(specialEventId: number, oddId: number) {
        return this.event.id === specialEventId && this.odd.id === oddId;
    }

    getOfferId() {
        return this.event.id;
    }

    public getOddSymbol(): string {
        return this.odd ? this.odd.name : '';
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/core/models/betSlip/SpecialSelection.ts